// DEPENDENCIES
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { isMobile } from '../../utils';
import SVGInline from "react-svg-inline"
import { BAND, MUSICIAN, SERVICE, LIVE_MUSIC } from '../../consts';

// components

// svg icons
import arrowBasicSVG from '../inlineSVGs/arrowBasicSVG';
import arrowPushSVG from '../inlineSVGs/arrowPushSVG';
import arrowRuleSVG from '../inlineSVGs/arrowRuleSVG';
import arrowHugeSVG from '../inlineSVGs/arrowHugeSVG';
import locationBlueSVG from '../inlineSVGs/locationBlueSVG';
import sleepingMugicsSVG from '../inlineSVGs/sleepingMugicsSVG';
import scopWhiteSVG from '../inlineSVGs/scopWhiteSVG';
import smallStarSVG from '../inlineSVGs/smallStarSVG';

// react icons
import FaArrowUp from 'react-icons/lib/fa/arrow-up';
import FaTrashO from 'react-icons/lib/fa/trash-o';
import FaPencil from 'react-icons/lib/fa/pencil';
import FaPause from 'react-icons/lib/fa/pause';
import FaPlay from 'react-icons/lib/fa/play';
import pushArrow from './images/mid_mobile_arrow.svg'
import ruleArrow from './images/high_mobile_arrow.svg'
import basicArrow from './images/free_mobile_arrow.svg'
import hugeArrow from './images/huge_mobile_arrow.svg'

// styles
import './PinsList.css';

const PinsList = ({ type, pins, editPin, removePin, newPin, bouncePin, datatypes, selectEnroll }) => {
    const getCategoriesImage = (pin) => {
        if (!datatypes) return null;
        const cat = datatypes.categories[pin.type].filter(c => c.name === pin.category);

        if (type.name === LIVE_MUSIC || type.name === SERVICE) {
            return cat && cat[0] && cat[0].images && cat[0].images[2].src
        }

        return null
    };

    const selectEnrollPlan = (pin, selectedEnroll) => {
        selectEnroll(pin, selectedEnroll);
    };

    const renderUpgradeTitle = (pin) => {
        if (pin.subscription.upgrade === 'mid') {
            return (
                <div className={`plan-graph mid`} >
                    <p>PUSH</p>
                    <span className="premium">פרימיום</span>
                </div>
            )
        }

        if (pin.subscription.upgrade === 'high') {
            return (
                <div className={`plan-graph high`} >
                    <p>RULE</p>
                    <span className="premium">פרימיום</span>
                </div>
            )
        }

        if (pin.subscription.upgrade === 'huge') {
            return (
                <div className={`plan-graph huge`} >
                    <p>SUPER</p>
                    <span className="premium">פרימיום</span>
                </div>
            )
        }
    };

    const renderTitle = (pin) => {
        if (!pin) return '';

        if (pin.subscription.upgrade) {
            return renderUpgradeTitle(pin);
        }

        if (pin.subscription.temp) {
            return  (
                <div className={`plan-graph`} >
                    {/*<p>CHOOSE PACKAGE</p>*/}
                </div>
                )
        }

        if (pin.subscription.enrolType === 'free') {
            return (
                <div className={`plan-graph ${pin.subscription.enrolType}`} >
                    <p>BASIC</p>
                </div>
            )
        }

        if (pin.subscription.enrolType === 'mid') {
            return (
                <div className={`plan-graph ${pin.subscription.enrolType}`} >
                    <p>PUSH</p>
                    <span className="premium">פרימיום</span>
                </div>
            )
        }

        if (pin.subscription.enrolType === 'high') {
            return (
                <div className={`plan-graph ${pin.subscription.enrolType}`}>
                    <p>RULE</p>
                    <span className="premium">פרימיום</span>
                </div>
            )
        }

        return (
            <div className={`plan-graph ${pin.subscription.enrolType}`}>
                <p>SUPER</p>
                <span className="premium">פרימיום</span>
            </div>
        )
    };

    const renderStatus = (pin) => {
        if (pin.isOnHold) {
            return (
                <div className="pin-status">
                    <i><FaPause/></i>
                    <div className="dot yellow" />
                    <div className="status-text-wrapper">
                        <p>ממתין </p>
                        <p>לאישור</p>
                    </div>
                </div>
            )
        }

        if (pin.subscription && pin.subscription.temp) {
            return (
                <div className="pin-status">
                    <i><FaPause/></i>
                    <div className="dot yellow" />
                    <div className="status-text-wrapper">
                        <p>חלקי</p>
                    </div>
                </div>
            )
        }

        if (!pin.isUserVerified) {
            return (
                <div className="pin-status">
                    <i><FaPause/></i>
                    <div className="dot yellow" />
                    <div className="status-text-wrapper">
                        <p>נדרש אישור מייל</p>
                    </div>
                </div>
            )
        }

        if (pin.type === LIVE_MUSIC && pin.date && !moment(pin.date).add(1, 'day').isAfter(moment())) {
            return (
                <div className="pin-status">
                    <i><FaPause/></i>
                    <div className="dot yellow" />
                    <div className="status-text-wrapper">
                        <p>תאריך חלף</p>
                    </div>
                </div>
            )
        }

        if (
            pin.subscription && pin.subscription.enrolType !== 'free' &&
            moment(pin.subscription.lastPayed).toDate() < moment().subtract(1, 'month').subtract(1, 'day').toDate()
        ) {
            return (
                <div className="pin-status">
                    <i><FaPause/></i>
                    <div className="dot red" />
                    <p>נדרש תשלום</p>
                </div>
            )
        }

        return (
            <div className="pin-status">
                <i><FaPlay/></i>
                <div className="dot green" />
                <p>באויר</p>
            </div>
        )
    };

    const renderUpgradeArrow = (pin) => {
        const upgrade = pin.subscription.upgrade;

        if (!isMobile())  {
            if (upgrade === 'mid') {
                return (
                    <div className={`arrow mid`} >
                        <SVGInline svg={arrowPushSVG} component="i" />
                    </div>
                )
            }

            if (upgrade === 'high') {
                return (
                    <div className={`arrow high`} >
                        <SVGInline svg={arrowRuleSVG} component="i" />
                    </div>
                )
            }

            if (upgrade === 'huge') {
                return (
                    <div className={`arrow huge`} >
                        <SVGInline svg={arrowHugeSVG} component="i" />
                    </div>
                )
            }
        }

        if (upgrade === 'mid') return <img src={pushArrow} alt="enrol-type-arrow"/>
        if (upgrade === 'high') return  <img src={ruleArrow} alt="enrol-type-arrow"/>
        if (upgrade === 'huge') return  <img src={hugeArrow} alt="enrol-type-arrow"/>
    };

    const renderArrow = (pin) => {
        if (pin.subscription.upgrade) {
            return renderUpgradeArrow(pin);
        }

        if (pin.subscription.temp) {
            return;
        }

        const enrolType = pin.subscription.upgrade || pin.subscription.enrolType;

        if (!isMobile())  {
            if (enrolType === 'free') {
                return (
                    <div className={`arrow ${enrolType}`} >
                        <SVGInline svg={arrowBasicSVG} component="i" />
                    </div>
                )
            }

            if (enrolType === 'mid') {
                return (
                    <div className={`arrow ${enrolType}`} >
                        <SVGInline svg={arrowPushSVG} component="i" />
                    </div>
                )
            }

            if (enrolType === 'high') {
                return (
                    <div className={`arrow ${enrolType}`} >
                        <SVGInline svg={arrowRuleSVG} component="i" />
                    </div>
                )
            }

            if (enrolType === 'huge') {
                return (
                    <div className={`arrow ${enrolType}`} >
                        <SVGInline svg={arrowHugeSVG} component="i" />
                    </div>
                )
            }
        }

        if (pin.subscription.enrolType === 'free') return <img src={basicArrow} alt="enrol-type-arrow"/>
        if (pin.subscription.enrolType === 'mid') return <img src={pushArrow} alt="enrol-type-arrow"/>
        if (pin.subscription.enrolType === 'high') return  <img src={ruleArrow} alt="enrol-type-arrow"/>
        if (pin.subscription.enrolType === 'huge') return  <img src={hugeArrow} alt="enrol-type-arrow"/>
    };

    const renderADButton = (pin) => {
        if (!pin.subscription) return;

        if (pin.subscription.temp) {
            return 'בחירה';
        }

        if (pin.subscription.enrolType === 'free') return 'שדרוג';

        return 'שינוי';
    };

    const renderUpgradeButton = pin => {
        if (pin.subscription && pin.subscription.upgrade) return <div className="change-plan-empty-wrapper"></div>


        return (
            <div className="change-plan-btn-wrapper rtl" onClick={() => selectEnrollPlan(pin)} >
                <div className="change-plan-btn">
                    <p>{renderADButton(pin)}</p>
                    <p>מודעה</p>
                </div>
            </div>
        )
    };

    const renderLocation = location =>  {
        let locationString = location.street && location.street.length > 13 ? location.street.substring(0, 13) + '...' : location.street;
        if (!window.locationString && location.city) {
            locationString = location.city.length > 13 ? location.city.substring(0, 13) + '...' : location.city
        }

        return locationString
    };

    const renderSubLocation = location => {
        if (!location) return '';

        if (location.revenueName) return location.revenueName;

        if (!location.street) return '';

        return `${location.street}, ${location.number || ''}`
    }

    // const renderDatePassedLabel = pin => {
    //     if (!pin || !pin.date) return null;
    //
    //     if (moment(pin.date).isAfter(moment())) return null;
    //
    //     return (
    //         <div className="label-date-passed-wrapper">
    //             <p className="label-date-passed">{'Date Passed'}</p>
    //         </div>
    //     )
    // };

    const titleLetters = isMobile() ? 13 : 25;

    return (
        <div className="pinsList rtl">
            <div className={"topStripe " + type.name}>
                <div className="text">
                    {type.name === BAND || type.name === MUSICIAN
                        ?
                        <div className={`band-finder-icon-wrapper ${type.name === BAND ? BAND : MUSICIAN}`}>
                            <SVGInline svg={scopWhiteSVG} component="i" className="band-finder-icon" />
                        </div>
                        : null
                    }
                     יש לך  ({pins.length}) {type.plural}
                </div>
            </div>
            {pins && pins.length ? pins.map((pin,index)=>{
                    if (!pin) return null;

                    return (
                        <div className="pinRow" key={type.name + index}>

                            <div className="leftBox rtl">

                                <div className="content">
                                    <div className={`inner-left ${type.name}`}>
                                        <div className="icon" style={{backgroundImage: 'url(' + getCategoriesImage(pin) + ')' }}>
                                            {type.name === BAND || type.name === MUSICIAN
                                                ?
                                                <SVGInline svg={smallStarSVG} component="i" className="small-start"/>
                                                : null
                                            }
                                        </div>
                                        <div className="pinName">{pin.name.length > titleLetters ? pin.name.substring(0, 13) + '...' : pin.name}</div>
                                    </div>
                                    <div className="inner-right">
                                        <SVGInline svg={locationBlueSVG} component="i" width="21px" height="21px" fill="#1cade3" className="locationIcon"/>
                                        <div className="location">{renderLocation(pin.location)}</div>
                                        <div className="location-sub-title">{renderSubLocation(pin.location)}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="rightBox rtl">
                                <div className="content">
                                    <div className="options">
                                        <i data-tooltip={`Edit your ad`} className="edit tooltip-md" onClick={()=>editPin(pin)}><FaPencil/></i>
                                        {pin.type === LIVE_MUSIC ?
                                            null
                                            : <i data-tooltip={`Bounce your ad to the top`} className="tooltip-lg" onClick={()=>bouncePin(pin)}><FaArrowUp/></i>

                                        }
                                        <i data-tooltip={`Delete your ad`} className="delete tooltip-md" onClick={()=>removePin(pin)} title="delete pin"><FaTrashO/></i>
                                    </div>

                                    {/*<div className="pin-status">*/}
                                        {/*{pin.isOnHold ? <span className={getClassName(pin)}>ON HOLD</span> : null}*/}
                                        {/*{!pin.subscription.isPayed ? <span className="not-payed">NOT PAYED</span> : null}*/}

                                    {/*</div>*/}
                                    <div className="separator top" />
                                    {renderStatus(pin)}
                                    <div className="separator bottom" />

                                    <div className="arrow-wrapper rtl">
                                        {renderTitle(pin)}
                                        {renderArrow(pin)}
                                    </div>
                                    {renderUpgradeButton(pin)}
                                </div>
                            </div>
                        </div>
                    )
                }):
                <div className="noPins">
                    <SVGInline svg={sleepingMugicsSVG} component="i" width="130px"/>
                    <div className="text">
                       אין לך {type.plural} כרגע!
                    </div>
                    <div className="addNew">
                        הוסיפו {type.singular}
                    </div>
                    <div className="plus" onClick={()=>newPin(type.name)}>+</div>
                </div>
            }
            {(pins && pins.length &&<div className="addRow">
                <div className="rowContent" onClick={()=>newPin(type.name)}>
                    <div className="plus">+</div>
                    <div className="text">
                        הוספת {type.singular}
                    </div>
                </div>
            </div>) || ""}


        </div>
    )
};

PinsList.propTypes = {
    type: PropTypes.object,
    pins: PropTypes.array,
    editPin: PropTypes.func,
    duplicatePin: PropTypes.func,
    removePin: PropTypes.func,
    newPin: PropTypes.func,
    bouncePin: PropTypes.func,
    datatypes: PropTypes.object,
    selectEnroll: PropTypes.func,
    isTempUser: PropTypes.bool,
};

export default PinsList;



// WEBPACK FOOTER //
// ./src/Components/Users/PinsList.js